import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon,
  SocialButtons,
  GetStartedInput,
  AboutBanner
} from '../../components'
// import {Row, Col} from 'react-flexbox-grid'
import Styles from './Toolkit.css'
import container from '../../helpers/container'
// import ReactPlayer from 'react-player'
import {CopyToClipboard} from 'react-copy-to-clipboard';

@CSSModules(Styles, {allowMultiple:true})
export default class Toolkit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      letterText: 'Dear Plan Administrator,\nI am an employee of [Company Name], and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about sustainable investment options that avoid the prison industrial complex.\nI am concerned about the financial and moral risks associated with investing my retirement savings in companies involved in the prison industrial complex through the prison and border industries. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from the prison industrial complex. In the wake of media attention driven by the nationwide protest of the senseless murder of George Floyd, more people are speaking out about the racial inequities that are imbedded in our society. As we move to right these injustices, people are demanding the right to know how they are contributing to these systemic issues of injustice. These facts point to a substantial financial risk of investing in prison industrial complex companies.\nI believe it is my right to know what companies my retirement savings are invested in. Can you please tell me how I can find out what companies involved in the prison industrial complex are held in each of the investment options offered in our company plan? Does our retirement plan offer any sustainable funds that avoid the prison industrial complex?\nSustainable investing is no longer just an ethical issue. It is a key factor impacting financial well-being. A growing body of research indicates that there is no financial trade-off in the returns of sustainable funds compared to traditional funds, and past guidelines from the Department of Labor have stated that "environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment" and can be used when making decisions related to fiduciary duty.\nThere is an online tool, prisonfreefunds.org, which screens many commonly available mutual funds for investments in companies profiting off of the prison industrial complex and identifies funds that are sustainable and avoid the prison and border industries. If none of our current plan options are sustainable funds that avoid the prison industrial complex, this tool could be used to find suitable mutual funds that could be included in our plan.\nThank you in advance for looking into this. I appreciate your time and look forward to hearing from you.\nBest,\n[Your Name]\n[Your contact information (company department, email, phone)]',
      copied: false,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  onCopy = () => {
    this.setState({copied: true});
  }

  copyToClipboard = () => {
    return (
      <CopyToClipboard
        onCopy={this.onCopy}
        text={this.state.letterText}
      >
        <button styleName='letter-boxquote-copy-button'>
          {
            this.state.copied ?
              (
                <span>
                  Copied!
                </span>
              ) :
              (
                <span>
                  Copy to clipboard<LinkIcon faclass='fa-files-o'/>
                </span>
              )
          }
        </button>
      </CopyToClipboard>
    )
  }

  render() {
    const title = 'Action Toolkit'
    const description = 'Get your money out of companies involved in the ' +
      'prison industrial complex. Use our action toolkit ' +
      'to make a change and move your money.'
    const message = 'Action toolkit to move your money'

    const bannerImage = 'green'
    const bannerHeadline = 'Prison Free Funds: Action Toolkit'
    const bannerSubtitle = 'Learn how to move your money out of private prisons and immigrant detention facilities.'

    const url = config.domain + config.routes.toolkit

    const resourceLinks = [
      ['AFSC’s Investigate Project','https://investigate.afsc.org/'],
      ['American Friends Service Committee (AFSC)','https://www.afsc.org/'],
      ['Coalition for Public Safety','https://www.coalitionforpublicsafety.org/'],
      ['Critical Resistance','http://criticalresistance.org/'],
      ['Ella Baker Center','https://ellabakercenter.org/'],
      ['Families Against Mandatory Minimums (FAMM)','https://famm.org/'],
      ['Just Leadership USA','https://jlusa.org/'],
      ['NorthStar Asset Management','https://northstarasset.com/'],
      ['Prison Policy Initiative','https://www.prisonpolicy.org/'],
      ['The Sentencing Project','https://www.sentencingproject.org/'],
      ['The Vera Institute of Justice','https://www.vera.org/'],
      ['Worth Rises','https://worthrises.org/'],
      ['The Prison Industry: Mapping Private Sector Players, 2020 edition, from Worth Rises',
       'https://worthrises.org/theprisonindustry2020'],
    ]

    const afscIcon = require('../../../static/images/AFSC-logo.jpg')
    const decarcerationIcon = require('../../../static/images/Decarceration-logo.jpg')
    const impactwiseIcon = require('../../../static/images/Impactwise-logo.jpg')
    const northstarIcon = require('../../../static/images/Northstar-logo.jpg')
    const robasciottiIcon = require('../../../static/images/Robasciotti-logo.jpg')
    const woweIcon = require('../../../static/images/Wowe-logo.jpg')

    const partnerLinks = [
      [afscIcon,'American Friends Service Committee (AFSC)','https://www.afsc.org/'],
      [decarcerationIcon,'The Decarceration Fund',null],
      [impactwiseIcon,'ImpactWise','https://impactwise.us/home/'],
      [northstarIcon,'NorthStar Asset Management','https://northstarasset.com/'],
      [robasciottiIcon,'Robasciotti & Philipson','https://robasciotti.com/'],
      [woweIcon,'Women of the World Endowment','https://wowendowment.org/']
    ]

    return (
      <div>
        {container.helmet(title, description, url)}
        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>
                  {bannerHeadline}
                </div>
                <div styleName='image-banner-subtitle'>
                  {bannerSubtitle}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>
            <div styleName='content-info'>
              <p>
                Elevated awareness of the nation’s unfinished racial justice agenda – highlighted by the killings of Black Americans at the hands of law enforcement, the family separation policy at the border, and other injustices – has spurred an accelerating conversation on how systemic racism is woven into our policing and incarceration institutions. While people across the country have joined in to protest police brutality and the racist policies disproportionately affecting Black people, indigenous people, and people of color, corporations continue to profit from these systems of oppression and exploitation.
              </p>
            </div>
          </div>
        </div>
        <div styleName='img-banner-wrapper' />
        <div styleName='toolkit'>
          <div styleName='toolkit-inner'>
            <div styleName='title'>
              Taking action against these injustices is long overdue.
            </div>
            <div styleName='content-info'>
              <p>
                As members of the same society that allows these systems to exist, we have a responsibility to take action. We have power when we come together to form a united front in the fight for justice and equality for all. 
              </p>
              <p>
                When we invest for the future, we are making the decision to support companies with our capital. But common investments like mutual funds can make it hard to know exactly which companies we are supporting. Prison Free Funds has empowered us with having access to this knowledge. Now it is up to us to make the choice to invest using our values. 
              </p>
            </div>
            <div styleName='title'>
              Now that we know some of our investments are supporting the prison industrial complex, how can we take action?
            </div>

            <div styleName='title'>
              If you’re an individual investor
            </div>
            <div styleName='content-info'>
              <p>
                It’s your money, and your financial advisor works for you. You just need to discuss what you have learned about your holdings and how you would like them changed in order to align with your values. An investment professional will advise you of potential risk and you make your own decisions.
              </p>
              <p>
                You can trade your own portfolio or tell your manager to do it. They may push back and tell you that you’ll make less money. You can reply, “Maybe, maybe not, but it’s my money, I want less risk, and incarceration-based companies are a risky business.” It’s a financial advisor's job to manage your money, so you should drive home this point in no uncertain terms.
              </p>
              <p>
                Ask for help finding the best choices. The advisor may advise against investing in a specific fund because it has a short or rocky history, so you may need to be patient as they find a better alternative. The goal is to remove the risk, not necessarily a specific fund. It is important to focus on risk (especially future risk) as well as returns. If your broker is tied to a big-name brand, they may only be able to offer products that the particular company has approved. If you want funds that are aligned with your values, and your broker is not able to provide them, it might be time to consider finding a new advisor.
              </p>
            </div>
            <div styleName='title'>
              Adding options to your retirement plan
            </div>
            <div styleName='content-info'>
              <p>
                If your employer-offered 401(k) already has investing options that are aligned with your values, that's great! However, many plans only offer diversified funds that own the whole market, including companies involved in the prison industrial complex. It is possible to change what the plan offers, but it will take more effort than if you have an IRA or a personal portfolio that you solely control and has more options. You will need to engage the plan administrator to help find the right blend of options to satisfy the many employees that all invest in the same group of mutual funds. This may take time and possibly some coordination with your co-plan participants.
              </p>
            </div>
            <div styleName='title'>
              Step 1 – Talk to your colleagues and build a coalition
            </div>
            <div styleName='content-info'>
              <p>
                To effectively advocate for new offerings through your employer-sponsored plan, first build a coalition of peers and interested co-workers inside your company. Your voice will be much stronger as a group. If you’re writing to someone in power, advocating on behalf of 20 or even 10 people carries a lot more weight than just one. One way to spur interest would be sharing the results from your Prison Free Funds search among fellow employees. All plan participants are offered the same group of mutual funds as you are, so they are probably asking the same questions right now.
              </p>
              <p>
                Some companies have “corporate responsibility teams.” If there isn’t one already, it may be time to create one for prison free investing. Communicate with your co-workers through a company intranet, employee portal, a company newsletter, corporate chats, or social media.
              </p>
            </div>
            <div styleName='title'>
              Step 2 – Identify the best people to speak with
            </div>
            <div styleName='content-info'>
              <p>
                The 401(k)/403(b) plan administrator, manager, or coordinator should be known if you are a plan participant, and that’s where to start. There could also be a chief corporate responsibility officer or employee engagement manager, and those could be good resources. An effective method is to go to the LinkedIn pages of those people and find who might have some sympathy for the cause. Do any of them volunteer or have connections with organizations working to reform the prison industrial complex? Look for indicators that they’re friendly to corporate responsibility and start contacting them in order of their friendliness. In a publicly listed company with more structure, a coalition is vital to signal to managers that it’s an important issue for many employees. If it’s a smaller company, the CFO or CEO could be approached directly. In a mid-size or family company, a family member could be more influential.
              </p>
            </div>
            <div styleName='title'>
              Step 3 – Bring a solution to the table
            </div>
            <div styleName='content-info'>
              <p>
                The usual starting point in these conversations is: “We want to reduce the future risk of our 401(k) fund choices. We also want to invest in a more just and equitable future. How can we enhance our 401(k) choices to do so?” Getting new fund choices added to the list of the existing plan options is a formal process, and could take up to a year to be added. Larger companies often have some form of investment committee, which engages an investment advisor. There may be some funds in your plan that you see contain only one company flagged by Prison Free Funds for involvement in the prison industrial complex. You could ask the plan administrator to call the fund manager and say, “Is there a substitute for this one company?”
              </p>
              <p>
                If the investment advisor and plan administrator refuse to help in swapping out some prison industrial complex-heavy funds for some prison industrial complex-free funds, you may need to get fellow employees to sign a petition requesting the change and send it to the investment committee. If you are told, “But you’ll make less money if you’re not invested in these companies,” you can say, “Actually, the prison and border industries are a risky investment. We want to diversify and be part of building a less violent future.”
              </p>
            </div>
            <div styleName='title'>
              Sample letter to plan administrator
            </div>
            <div styleName='content-info'>
              <div styleName='letter-boxquote'>
                <p>
                  Dear Plan Administrator,
                </p>
                <p>
                  I am an employee of <strong>[Company Name]</strong>, and I participate in our company 401(k) plan, which represents the bulk of my retirement savings. I am writing to inquire about sustainable investment options that avoid the prison industrial complex.
                </p>
                <p>
                  I am concerned about the financial and moral risks associated with investing my retirement savings in companies involved in the prison industrial complex through the prison and border industries. A growing body of evidence indicates that companies that are socially conscious end up performing better than those that do not. Many large pension funds have already moved to divest from the prison industrial complex. In the wake of media attention driven by the nationwide protest of the senseless murder of George Floyd, more people are speaking out about the racial inequities that are imbedded in our society. As we move to right these injustices, people are demanding the right to know how they are contributing to these systemic issues of injustice. These facts point to a substantial financial risk of investing in prison industrial complex companies.
                </p>
                <p>
                  <strong>I believe it is my right to know what companies my retirement savings are invested in.</strong> Can you please tell me how I can find out what companies involved in the prison industrial complex are held in each of the investment options offered in our company plan? Does our retirement plan offer any sustainable funds that avoid the prison industrial complex?
                </p>
                <p>
                  Sustainable investing is no longer just an ethical issue. It is a key factor impacting financial well-being. A growing body of research indicates that there is no financial trade-off in the returns of sustainable funds compared to traditional funds, and past guidelines from the Department of Labor have stated that “environmental, social, and governance factors may have a direct relationship to the economic and financial value of an investment” and can be used when making decisions related to fiduciary duty.
                </p>
                <p>
                  There is an online tool, <strong>prisonfreefunds.org</strong>, which screens many commonly available mutual funds for investments in companies profiting off of the prison industrial complex and identifies funds that are sustainable and avoid the prison and border industries. <strong>If none of our current plan options are sustainable funds that avoid the prison industrial complex, this tool could be used to find suitable mutual funds that could be included in our plan.</strong>
                </p>
                <p>
                  Thank you in advance for looking into this. I appreciate your time and look forward to hearing from you.
                </p>
                <p>
                  Best,
                </p>
                <p> 
                  <strong>[Your Name]</strong>
                </p>
                <p>
                  <strong>[Your contact information (company department, email, phone)]</strong>
                </p>
              </div>
              <Link
                to={'https://iyv-charts.s3-us-west-2.amazonaws.com/files/Sample+401k+letter+Prison+Free+Funds.docx'}
                alt='Download Sample 401k letter Prison Free Funds.docx'
              >
                <button styleName='letter-boxquote-copy-button'>
                  Download as Word doc<LinkIcon faclass='fa-download'/>
                </button>
              </Link>
              {this.copyToClipboard()}
            </div>
            <div styleName='title'>
              Want to learn more?
            </div>
            <div styleName='content-info'>
              <p>
                If you want to learn more about the prison industrial complex and find ways to make a difference, check our these organizations and resources:
              </p>
              {
                resourceLinks.map((e, i) => {
                  return (
                    <p>
                      <Link to={e[1]} title={e[0]} key={'rl'+i} xstrong>
                        {e[0]}
                      </Link>
                    </p>
                  )
                })
              }
            </div>

            <div styleName='title'>
              Thanks to our advisory committee
            </div>
            <div styleName='content-info'>
              <p>
                A special thank you to the organizations that provided us with data and feedback as we worked on Prison Free Funds. This site would not have been possible without their help.
              </p>
              <div styleName='partner-logo-row'>
                {
                  partnerLinks.map((e, i)=>{
                    if (e[2]) {
                      return (
                        <div key={'pl'+i} styleName='partner-logo'>
                          <Link to={e[2]} title={e[1]}>
                            <img
                              src={e[0]}
                              styleName='partner-logo-img'
                              alt={e[1]}
                            />
                          </Link>
                        </div>
                      )
                    }
                    return (
                      <div key={'pl'+i} styleName='partner-logo'>
                        <img
                          src={e[0]}
                          styleName='partner-logo-img'
                          alt={e[1]}
                        />
                      </div>
                    )
                  })
                }
              </div>
            </div>
            <br/>
            <br/>
            <br/>
            { /* <SocialButtons message={message} link={url}/> */ }
          </div>
        </div>
        <GetStartedInput />
        <div styleName='ab-container'>
          <div styleName='ab-container-inner'>
            <AboutBanner />
          </div>
        </div>
      </div>
    )
  }
}
